// Loads Apollo Client full messages for errors and warnings.
// In production they will be kept as
// "An error occurred! For more details, see the full error text at https://go.apollo.dev/..."
export default () => {
  if (process.env.NODE_ENV !== 'production') {
    import(/* webpackChunkName: "apolloClientDev" */ '~/lazy_apollo/client/dev').then(({ loadDevMessages, loadErrorMessages }) => {
      loadDevMessages();
      loadErrorMessages();
      console.log('[POPMENU] Apollo Client Error Messages Loaded');
    }).catch((e: unknown) => {
      console.error('[POPMENU] Apollo Client Error Messages Failed to Load:', e);
    });
  }
};
